import { render } from "./HomeworkAssignment.vue?vue&type=template&id=37d198b2&scoped=true"
import script from "./HomeworkAssignment.vue?vue&type=script&lang=js"
export * from "./HomeworkAssignment.vue?vue&type=script&lang=js"

import "./HomeworkAssignment.vue?vue&type=style&index=0&id=37d198b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d198b2"]])

export default __exports__